var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 2C4.686 2 2 4.685 2 7.995a6 6 0 0 0 6 5.996c3.314 0 6-2.685 6-5.996A6 6 0 0 0 8 2M0 7.995A8 8 0 0 1 8 0c4.418 0 8 3.58 8 7.995a8 8 0 0 1-8 7.996c-4.418 0-8-3.58-8-7.996m8-3.998a1 1 0 0 1 1 1v2.584l1.707 1.706A1 1 0 0 1 9.293 10.7l-2-1.998A1 1 0 0 1 7 8.002V4.997a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgClock;